var path = 'src/app/patients/medications/medications.html';
var html = "<h1 class=page-header>Medications</h1> <div medications-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/medications/medications.html
 ** module id = 520
 ** module chunks = 0
 **/